module.exports = __webpack_public_path__ + "static/media/covid_qr_export_3.c8636125.png";